<ol class="breadcrumb page-breadcrumb">
  <li class="breadcrumb-item">
    <a href="javascript:void(0);" [routerLink]="['/teacher/home']">Home</a>
  </li>
  <li class="breadcrumb-item active">Gestão de Indicações</li>
  <li class="position-absolute pos-top pos-right d-none d-sm-block">
    <span class="js-get-date"></span>
  </li>
</ol>
<div class="row">
  <div class="col-sm-6 col-xl-3">
    <div class="p-3 bg-info rounded overflow-hidden position-relative text-white mb-g">
      <div class="">
        <h3 class="display-4 d-block l-h-n m-0 fw-500">
          {{ this.contacts?.length ?? 0 }}
          <small class="m-0 l-h-n">Total de Indicações</small>
        </h3>
      </div>
      <i class="fal fa-users position-absolute pos-right pos-bottom opacity-15  mb-n1 mr-n4" style="font-size: 6rem;"></i>
    </div>
  </div>
  <div class="col-sm-6 col-xl-3">
    <div class="p-3 bg-secondary rounded overflow-hidden position-relative text-white mb-g">
      <div class="">
        <h3 class="display-4 d-block l-h-n m-0 fw-500">
          {{ creditDebitSummary.creditBlock | currency:'BRL':'symbol':'1.2-2' }}
          <small class="m-0 l-h-n">Crédito Bloqueado</small>
        </h3>
      </div>
      <i class="fal fa-gem position-absolute pos-right pos-bottom opacity-15  mb-n1 mr-n4" style="font-size: 6rem;"></i>
    </div>
  </div>
  <div class="col-sm-6 col-xl-3">
    <div class="p-3 bg-success rounded overflow-hidden position-relative text-white mb-g">
      <div class="">
        <h3 class="display-4 d-block l-h-n m-0 fw-500">
          {{ creditDebitSummary.availableCredit | currency:'BRL':'symbol':'1.2-2' }}
          <small class="m-0 l-h-n">Crédito Disponível</small>
        </h3>
      </div>
      <i class="fal fa-gem position-absolute pos-right pos-bottom opacity-15  mb-n1 mr-n4" style="font-size: 6rem;"></i>
    </div>
  </div>
  <div class="col-sm-6 col-xl-3">
    <div class="p-3 bg-primary rounded overflow-hidden position-relative text-white mb-g">
      <div class="">
        <h3 class="display-4 d-block l-h-n m-0 fw-500">
          {{ creditDebitSummary.usedCredit | currency:'BRL':'symbol':'1.2-2' }}
          <small class="m-0 l-h-n">Crédito Utilizado</small>
        </h3>
      </div>
      <i class="fal fa-gem position-absolute pos-right pos-bottom opacity-15  mb-n1 mr-n4" style="font-size: 6rem;"></i>
    </div>
  </div>
</div>
<div class="row">
  <div class="col-12">
    <div id="panel-8" class="panel">
      <div class="panel-hdr bg-primary-600 bg-primary-gradient">
        <h2>Gestão de Indicações</h2>
        <div class="panel-toolbar ml-2">
          <button
            type="button"
            class="btn btn-success btn-xs"
            data-toggle="tooltip"
            title="Novo Interessado"
            (click)="newIndication(mdStudentNewIndication)"
          >
            Novo
          </button>
        </div>
      </div>
      <div class="panel-container show">
        <div
          class="panel-content py-2 rounded-bottom border-faded border-left-0 border-right-0 border-bottom-0 text-muted d-flex"
        >
          <div class="col-sm-12" *ngIf="!showTable">
            <div class="alert alert-warning m-2" role="alert">
              {{ returnMessage }}
            </div>
          </div>
          <div class="col-sm-12" *ngIf="showTable">
            <managed-table
              [dataTitle]=""
              [rows]="contacts"
              [columns]="columns"
              [hasActions]="true"
              [ngTableFiltering]="true"
              [showFilterRow]="false"
              [hasFilter]="true"
              [previewEnable]="true"
              (previewClick)="preview($event)"
              [editEnable]="true"
              (editClick)="edit($event)"
              [auxEnable]="true" [auxIcon]="iconCreditUse" [titleAux]="titleCreditUse" (auxClick)="onCreditUse($event)"
            >
            </managed-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #mdStudentNewIndication let-c="close" let-d="dismiss">
  <div class="modal-header bg-primary">
      <h5 class="modal-title">Dados da indicação</h5>
      <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="dismissModal()">
          <span aria-hidden="true"><i class="fa fa-times"></i></span>
      </button>
  </div>
  <div class="modal-body">
    <teacher-new-indication id="{{ indicationId }}" preview="{{ false }}"></teacher-new-indication>
  </div>
</ng-template>
